import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  colors: {
    primary: '#DA015C',
    secondary: '#000000',
    accent: '#f39c12',
    dark: '#000000',
    light: '#f5f5f5',
    white: '#ffffff',
    black: '#000000',
    gradient: 'linear-gradient(135deg, #DA015C 0%, #b80149 100%)'
  },
  fonts: {
    main: "'Poppins', sans-serif"
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  },
  shadows: {
    small: '0 2px 8px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.15)',
    large: '0 8px 24px rgba(0, 0, 0, 0.2)'
  }
}; 